import React, { useMemo } from 'react';

import {
  IconButton,
  FilterListIcon,
  FilterListOffIcon,
  InputAction,
} from '@gogame/components';

import { useScreenDispatch, useScreenState, SET_FILTERS } from '../Screen';

const key = 'applyFilters';

export const ThroughFiltersComponent = ({ value }) => {
  const dispatch = useScreenDispatch();
  const screenState = useScreenState();

  const enabled = useMemo(() => {
    return !!screenState?.filters?.[key];
  }, [screenState?.filters?.[key]]);

  const handleClick = () => {
    dispatch({
      type: SET_FILTERS,
      payload: {
        ...screenState?.filters,
        [key]: !enabled,
      },
    });
  };

  const icon = useMemo(() => {
    return enabled ? (
      <FilterListIcon color={'action'} />
    ) : (
      <FilterListOffIcon color={'action'} />
    );
  }, [enabled]);

  const tooltipText = useMemo(() => {
    return `Search ${enabled ? 'through' : 'despite'} the selected filters`;
  }, [enabled]);

  if (enabled === undefined) {
    return null;
  }

  return (
    <InputAction
      color={'inherit'}
      icon={icon}
      tooltip={tooltipText}
      onClick={handleClick}
      // style={{
      //   pointerEvents: 'auto',
      // }}
      // data-сy={'Include Filters in Search'}
    />
  );
};
